<template>
    <div class="form-item">
        <label class="label-caption">Serviço</label>
        <select :value="tpservicoSelecionado" @change="atualizarObj" class="form-control" v-bind="$attrs"> 
            <option v-if="isLoading" disabled>Carregando...</option>
            <option v-if="!lsDados || lsDados.length === 0" disabled>Nenhuma opção disponível</option>
            <option v-for="obj in lsDados" :key="obj.id" :value="obj.id">{{ obj.nmobratpservico }}</option>
        </select>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { genericPost } from "@/funcoes/api";
import { globalStore } from "@/globals";

const props = defineProps({
    ckAddTodos: {type: Boolean, default: false},
    ckCidadao: {type: Boolean, default: false},
    ckPesquisar: {type: Boolean, default: true},
    tpservicoSelecionado: {type: Number, default: null,},
});

const emit = defineEmits(["update:tpservicoSelecionado"]);
const lsDados = ref([]);
const isLoading = ref(false);

const fetchData = async () => {
    try {
        isLoading.value=true;
        const response = await genericPost('/listas/obras/tpservicos', {
            idmunicipio: globalStore.idmunicipio, 
            ativo: 'S',
            intparam1: props.ckCidadao ? 1 : 0});
        lsDados.value = response;
        if (props.ckAddTodos){lsDados.value.unshift({ id: 0, nmipservico: 'TODOS' });}
    } catch (error) {console.error("Erro de conexão com a API:", error);
    }finally{isLoading.value=false;}
};

const atualizarObj = (event) => {
    emit("update:tpservicoSelecionado", Number(event.target.value));
};

onMounted(() => {
    if (props.ckPesquisar){fetchData();}
});

watch(
    () => props.ckPesquisar,
    (newValue, oldValue) => {
        if (newValue && !oldValue) {fetchData();}
    }
);
</script>
  